import $ from 'jquery';

export default function headerSection() {
	$('.quotes').each(function() {
		const $quotes = $(this);
		const $quotesCards = $quotes.find('.quotes_cards');
		const $inner = $quotes.find('.inner');
		const $leftControl = $quotes.find('.control.left');
		const $rightControl = $quotes.find('.control.right');
		$inner.prepend($inner.find('.card:last'));

		const $cardsClone = $inner.find('.card').clone();

		$inner.append($cardsClone.clone());

		// Scrolling variables
		let animating = false;
		let offsetX = 0;
		let deltaX = 0;
		let mouseX = 0;

		// Dragging variables
		let dragging = false;
		let firstTouch;
		let lastTouch;
		let momentum = 0;
		let mSeq = 0;

		function updateCards() {
			const $cards = $inner.find('.card');
			const firstCardLeft = $cards.first()[0].getBoundingClientRect().left
			const lastCardRight = $cards.last()[0].getBoundingClientRect().right
			const cardsWidth = lastCardRight - firstCardLeft

			if (cardsWidth < $quotesCards.width() * 3) {
				$inner.append($cardsClone.eq($cards.length % $cardsClone.length).clone());
				updateCards();
			}
		}

		window.u = updateCards;
		$(window).resize(updateCards);
		updateCards();

		function quotesTick() {
			if (dragging) return;

			const distX = mouseX - offsetX
			offsetX += distX / 20
		}

		function mouseMove(e) {
			if (firstTouch) {
				if (
					Math.abs(firstTouch.screenX - e.touches[0].screenX) <
					Math.abs(firstTouch.screenY - e.touches[0].screenY)
				) {
					dragging = false;
					return;
				}
				firstTouch = null;
			}
			if (dragging) {
				e.preventDefault();
				e = e.originalEvent
				const rect = this.getBoundingClientRect();
				mouseX = e.clientX + $quotes.width();

				const scrollLeft = $quotesCards.scrollLeft() - (e.movementX != null ? e.movementX : e.touches[0].screenX - lastTouch.screenX);
				const $cards = $inner.find('.card');
				const firstCard = $cards[0].getBoundingClientRect().left
				const nextCard = $cards[1].getBoundingClientRect().left
				const lastCard = $cards[$cardsClone.length].getBoundingClientRect().left
				const offset = lastCard - firstCard
				$quotesCards.scrollLeft((scrollLeft + offset) % offset);
				momentum = (e.movementX != null ? e.movementX : e.touches[0].screenX - lastTouch.screenX);
				if (e.touches) {
					lastTouch = e.touches[0]
				}
			}
		}

		function mouseDown(e) {
			lastTouch = e.originalEvent.touches && e.originalEvent.touches[0];
			firstTouch = lastTouch;
			dragging = true;
			momentum = 0;
		}

		function mouseUp(e) {
			if (!dragging) return
			dragging = false;
			let scrollLeft = $quotesCards.scrollLeft();
			const $cards = $inner.find('.card');
			const firstCard = $cards[0].getBoundingClientRect().left
			const nextCard = $cards[1].getBoundingClientRect().left
			const lastCard = $cards[$cardsClone.length].getBoundingClientRect().left
			const offset = lastCard - firstCard
			const cardDist = nextCard - firstCard
			const targetX = Math.round((scrollLeft - (momentum * 20)) / cardDist) * cardDist
			animating = true;

			const dur = 1 + Math.abs(momentum / 500);

			function scaleEase(a, b, pos) {
				const easeOutQuint = x => 1 - Math.pow(1 - x, 5)
				return (easeOutQuint(pos) * (b - a)) + a
			}

			window.scaleEase = scaleEase

			const start = scrollLeft;
			const end = targetX;

			mSeq++;
			const cmSeq = mSeq;

			for (let p = 0; p <= 1; p += 1 / (dur * 60)) {
				setTimeout(() => {
					console.log(mSeq, cmSeq)
					if (!dragging && cmSeq === mSeq) {
						$quotesCards.scrollLeft(((scaleEase(start, end, p) + offset * 10) % offset));
					}
				}, p * dur * 1000);
			}

			setTimeout(() => {
				if (cmSeq === mSeq) {
					animating = false;
				} else {
					console.log('XXXXXXXXXXXXXXXXXXXXXX');
				}
			}, dur * 1000);
		}

		function handleResize() {
			let scrollLeft = $quotesCards.scrollLeft();
			const $cards = $inner.find('.card');
			const firstCard = $cards[0].getBoundingClientRect().left
			const nextCard = $cards[1].getBoundingClientRect().left
			const cardDist = nextCard - firstCard
			const targetX = Math.round(scrollLeft / cardDist) * cardDist
			$quotesCards.scrollLeft(targetX)
		}

		$(window).resize(handleResize);

		if (screen.width > 480) {
			setInterval(quotesTick, 16) // ~60fps
		}

		$inner.on('mousemove touchmove', mouseMove);
		$inner.on('mousedown touchstart', mouseDown);
		$(window).on('mouseup touchend', mouseUp);

		function scrollLeft() {
			if (animating) return;
			animating = true;

			const $cards = $inner.find('.card');
			const firstCard = $cards[0].getBoundingClientRect().left
			const nextCard = $cards[1].getBoundingClientRect().left
			const lastCard = $cards[$cardsClone.length].getBoundingClientRect().left
			const offset = lastCard - firstCard

			let scrollLeft = $quotesCards.scrollLeft();

			scrollLeft = ((scrollLeft + offset) % offset) + offset;

			$quotesCards.scrollLeft(scrollLeft)

			scrollLeft -= nextCard - firstCard

			$quotesCards.animate({
				scrollLeft: scrollLeft
			}, 1000, 'easeOutQuint', function() {
				animating = false;
			});
		}

		function scrollRight() {
			if (animating) return;
			animating = true;

			const $cards = $inner.find('.card');
			const firstCard = $cards[0].getBoundingClientRect().left
			const nextCard = $cards[1].getBoundingClientRect().left
			const lastCard = $cards[$cardsClone.length].getBoundingClientRect().left
			const offset = lastCard - firstCard

			let scrollLeft = $quotesCards.scrollLeft();

			scrollLeft = ((scrollLeft + offset) % offset) + offset;

			$quotesCards.scrollLeft(scrollLeft)

			scrollLeft += nextCard - firstCard

			$quotesCards.animate({
				scrollLeft: scrollLeft
			}, 1000, 'easeOutQuint', function() {
				animating = false;
			});
		}

		$leftControl.click(scrollLeft);
		$rightControl.click(scrollRight);
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/quotes.js